// extracted by mini-css-extract-plugin
export default {"divider":"BasicView_divider__3vwkx","header":"BasicView_header__l6nKe","noprint":"BasicView_noprint__dnO4f","headerInner":"BasicView_headerInner__fOg9H"};